import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function WhyArissa() {
  const differentiators = ['Technology-driven workflows for faster resolution', 'Personal case ownership by experienced professionals', 'National reach combined with deep local expertise', 'Transparent, actionable reporting and analytics', 'Long-term partnership approach focused on your goals'];
  return <section id="about" className="py-24 bg-brand-paper" data-id="element-349">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-350">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-351">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-352">
            <div className="absolute -inset-4 bg-brand-gold/20 rounded-2xl transform -rotate-3" data-id="element-353"></div>
            <img src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=2400&q=90" alt="Doctor consulting with a patient, showing care and connection" className="relative rounded-2xl shadow-2xl object-cover h-[600px] w-full" data-id="element-354" />

            {/* Overlay Card */}
            <div className="absolute -bottom-8 -right-8 bg-brand-navy p-8 rounded-xl shadow-xl max-w-xs hidden md:block" data-id="element-355">
              <div className="text-brand-gold font-serif text-4xl font-bold mb-2" data-id="element-356">
                Commitment
              </div>
              <p className="text-white/90 text-sm leading-relaxed" data-id="element-357">
                Delivering valued care and long-lasting partnerships through
                intelligence and personal connection.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-358">
            <h2 className="text-brand-gold font-semibold tracking-wider uppercase text-sm mb-3" data-id="element-359">
              Why Choose Us
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif text-brand-navy mb-6" data-id="element-360">
              Built on intelligence and personal connection
            </h3>
            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-361">
              We understand that behind every claim is a person, and behind
              every program is a bottom line. Our customized programs balance
              compassionate care with rigorous cost containment.
            </p>

            <ul className="space-y-6" data-id="element-362">
              {differentiators.map((item, index) => <li key={index} className="flex items-start" data-id="element-363">
                  <CheckCircle2 className="w-6 h-6 text-brand-gold mr-4 flex-shrink-0 mt-0.5" data-id="element-364" />
                  <span className="text-gray-800 font-medium text-lg" data-id="element-365">
                    {item}
                  </span>
                </li>)}
            </ul>

            <div className="mt-12" data-id="element-366">
              <a href="#contact" className="inline-flex items-center justify-center px-8 py-4 border-2 border-brand-navy text-brand-navy font-semibold rounded hover:bg-brand-navy hover:text-white transition-colors" data-id="element-367">
                Meet Our Team
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}